"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = require("coveo-search-ui");
function lazyCoveoDistanceResources() {
    coveo_search_ui_1.LazyInitialization.registerLazyComponent("DistanceResources", function () {
        return new Promise(function (resolve, reject) {
            require.ensure(["./DistanceResources"], function () {
                var loaded = require("./DistanceResources.ts")["DistanceResources"];
                resolve(loaded);
            }, coveo_search_ui_1.LazyInitialization.buildErrorCallback("DistanceResources", resolve), "DistanceResources");
        });
    });
}
exports.lazyCoveoDistanceResources = lazyCoveoDistanceResources;



//////////////////
// WEBPACK FOOTER
// ./src/ui/distance/LazyDistanceResources.ts
// module id = 53
// module chunks = 14